import { LayoutComponent } from './layout/layout/layout.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SettingsComponent } from './components/settings/settings.component';
import { CereriComponent } from './components/cereri/cereri.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { AdminSetariComponent } from './platform/nomenclatoare/administrativ/admin-setari/admin-setari.component';
import { TokenComponent } from './components/token/token.component';
import { TokenGuard } from './guards/token.guard';
import { RegistruComponent } from './components/registru/registru.component';
import { PermissionsGuard } from './guards/permissions.guard';
import { SlugPageComponent } from './components/slugPage/slug-page.component';
import { AccesInterzisComponent } from './shared/acces-interzis/acces-interzis.component';
import { BorderouComponent } from './components/borderou/borderou.component';

import { CerereDetaliiSabloaneComponent } from './components/cereri/cereri-detalii/sabloane/cerere-detalii-sabloane.component';
import { CerereSabloaneComponent } from './platform/nomenclatoare/cerere-sabloane/cerere-sabloane.component';
import { ConfirmareDocumenteComponent } from './components/confirmare-documente/confirmare-documente.component';
import { NotificariComponent } from './components/notificari/notificari.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: '/cereri',
        pathMatch: 'full',

    },
    {
        path: 'access-denied',
        component: AccesInterzisComponent,
    },
    {
        path: '',
        component: LayoutComponent,
        canActivate: [TokenGuard, PermissionsGuard],
        children: [
            {
                path: 'dashboard',
                component: DashboardComponent,
            },
            {
                path: 'settings',
                component: SettingsComponent,
            },
            {
                path: 'borderou',
                component: BorderouComponent,
            },
            {
                path: 'sabloane',
                component: CerereSabloaneComponent,
            },
            {
                path: 'cereri',
                component: CereriComponent,
            },
            {
                path: 'registru',
                component: RegistruComponent,
            },
            {
                path: 'confirmare-documente',
                component: ConfirmareDocumenteComponent,
            },
            {
                path: 'notificari',
                component: NotificariComponent,
            },
            {
                path: 'admin-settings',
                component: AdminSetariComponent,
            },
            { path: ':slug', component: SlugPageComponent },
        ],
    },
    {
        path: 'token/:token',
        component: TokenComponent,
    },
    {
        path: '**',
        redirectTo: '/cereri',
    },
];

@NgModule({
    imports: [
        RouterModule.forRoot(routes, {
            scrollPositionRestoration: 'enabled',
            anchorScrolling: 'enabled',
            useHash: true,
        }),
    ],
    exports: [RouterModule],
})
export class AppRoutingModule { }
